<!-- Copyright (C) 2018 HTC Global Services, Inc. - All Rights Reserved -->

<div [ngStyle]="{'display': isLoaderShown ? 'block' : 'none' }" class="loading-spinner">
    <img src="assets/images/three-dots.svg" alt="{{'Alt.loaderImage' | translate}}" class="img-icon" />
</div>
